import type { SVGProps } from 'react';

export const QuestionCustomization = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="32px"
    role="img"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{'question customization'}</title>
    <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
      <circle cx="16" cy="16" fill="#F2F4F9" r="16" />
      <polygon
        fill="#898C9A"
        points="16.5 21.75 10.3282549 24.9946784 11.5069533 18.1223392 6.51390658 13.2553216 13.4141274 12.2526608 16.5 6 19.5858726 12.2526608 26.4860934 13.2553216 21.4930467 18.1223392 22.6717451 24.9946784"
      />
    </g>
  </svg>
);
